import { z } from 'zod'
import { FileStatsSchema } from './file-stats.ts'
import { FileUploadResponseSchema } from './file-upload-response.ts'
import { QuickframeTagsSchema } from './metadata/quickframe-tags.ts'

export const MetaTagResultSchema = z.object({
  tags: QuickframeTagsSchema,
  fileStats: FileStatsSchema,
  tagsResult: z.string(),
  uploadResult: FileUploadResponseSchema,
})

export type MetaTagResult = z.infer<typeof MetaTagResultSchema>

export const MetaTagWebhookInputSchema = z.object({
  tags: QuickframeTagsSchema.pick({ assetFileUuid: true }),
})

export type MetaTagWebhookInput = z.infer<typeof MetaTagWebhookInputSchema>
